<template>
  <div class="kaltura__list">
    <div class="search-form">
      <label for="search" >Search Kaltura videos</label>
      <input name="search" type="text" v-on:keyup.enter="search()" placeholder="Search" v-model="searchText" />
      <button class="kaltura__list__btn" title="Search" @click.stop.prevent="search()">Search</button>
    </div>
    <ul>
      <li @click.stop.prevent="open(item)" class="kaltura__list__item" title="Select kaltura" v-for="item in mediaList" v-bind:key="item.id" :style="'background:url(' +  item.thumbnailUrl + ') no-repeat center center'">
        <div class="title" :class="item.id === selectedMedia.id ? 'selected-title' : ''"><span>{{item.name !== undefined ? item.name.substring(0, 25) : ''}}</span></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'list',
  computed: {
    ...mapGetters(['mediaList', 'selectedMedia'])
  },
  data: () => ({
    searchText: ''
  }),
  created() {
    if (this.mediaList <= 0) {
      this.loadMediaList('')
    }
  },
  methods: {
    ...mapActions(['loadMediaList', 'setMedia']),
    search(item) {
      this.loadMediaList(this.searchText)
    },
    open(item) {
      this.setMedia(item)
    }
  }
}
</script>
